import { collection, addDoc, serverTimestamp, query, orderBy, limit, getDocs } from 'firebase/firestore';
import { db } from '../lib/firebase';
import { AdminLog, ActivityLogType } from '../types/admin';

export async function createAdminLog(
  type: ActivityLogType,
  targetUserId: string,
  byAdminId: string,
  meta: Record<string, any> = {},
  targetUserEmail?: string,
  byAdminEmail?: string
): Promise<void> {
  try {
    const logsRef = collection(db, 'admin_logs');
    
    await addDoc(logsRef, {
      type,
      targetUserId,
      targetUserEmail: targetUserEmail || '',
      byAdminId,
      byAdminEmail: byAdminEmail || '',
      createdAt: serverTimestamp(),
      meta,
    });
    
    console.log(`[AdminLog] Created log: ${type} for user ${targetUserId}`);
  } catch (error) {
    console.error('[AdminLog] Error creating log:', error);
  }
}

export async function getRecentAdminLogs(limitCount: number = 20): Promise<AdminLog[]> {
  try {
    const logsRef = collection(db, 'admin_logs');
    const q = query(logsRef, orderBy('createdAt', 'desc'), limit(limitCount));
    
    const snapshot = await getDocs(q);
    
    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    } as AdminLog));
  } catch (error) {
    console.error('[AdminLog] Error fetching logs:', error);
    return [];
  }
}

export function getLogTypeLabel(type: ActivityLogType): string {
  const labels: Record<ActivityLogType, string> = {
    SUBSCRIPTION_UPDATE: 'อัปเดตแพ็กเกจ',
    ROLE_CHANGE: 'เปลี่ยนบทบาท',
    INSTRUCTOR_STATUS: 'เปลี่ยนสถานะผู้สอน',
    EMAIL_CHANGE: 'เปลี่ยนอีเมล',
    MAINTENANCE_TOGGLE: 'เปิด/ปิดระบบ',
    USER_BANNED: 'แบนผู้ใช้',
    USER_UNBANNED: 'ปลดแบนผู้ใช้',
  };
  
  return labels[type] || type;
}

export function getLogTypeColor(type: ActivityLogType): string {
  const colors: Record<ActivityLogType, string> = {
    SUBSCRIPTION_UPDATE: 'text-blue-600 bg-blue-100',
    ROLE_CHANGE: 'text-blue-600 bg-blue-100',
    INSTRUCTOR_STATUS: 'text-blue-600 bg-blue-100',
    EMAIL_CHANGE: 'text-green-600 bg-green-100',
    MAINTENANCE_TOGGLE: 'text-red-600 bg-red-100',
    USER_BANNED: 'text-red-700 bg-red-200',
    USER_UNBANNED: 'text-green-700 bg-green-200',
  };
  
  return colors[type] || 'text-gray-600 bg-gray-100';
}
